module.exports = __webpack_public_path__ + "img/select.45064c11.svg";